import { inViewFadeUp } from '@helpers/animate';
import { baseGrid } from '@helpers/grid';
import { from, Device, until } from '@helpers/media';
import { h3, contentStyles, paragraph } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Button/Button.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  padding: var(--sectionSpacing) 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
const IntroContent = styled.div `
  ${baseGrid};
  width: 100%;
  margin-bottom: var(--introSpacing);
`;
const Title = styled.h2 `
  ${h3};
  margin: 0;
  grid-column: 1 / span 12;
  grid-row: 1;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 6;
    grid-row: 1;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const Content = styled.div `
  ${contentStyles};
  grid-column: 1 / span 12;
  grid-row: 2;
  margin: calc(var(--introSpacing) / 2) 0 0;

  @media ${from(Device.TabletLarge)} {
    grid-column: 7 / span 6;
    grid-row: 1;
    margin: 0;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const CarouselContainer = styled.div `
  overflow: hidden;
`;
const CarouselInner = styled.div `
  --visibleItems: 1;
`;
const CarouselWrapper = styled.div ``;
const Item = styled.li `
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
  padding-right: var(--itemGutter);
  user-select: none;

  img {
    pointer-events: none;
  }
`;
const Image = styled.img `
  display: block;
  height: 100%;
  object-fit: contain;
  object-position: center center;

  ${({ maxHeight }) => maxHeight &&
    css `
      max-height: ${maxHeight}px;
    `}
`;
const ItemInner = styled.div `
  aspect-ratio: 16 / 9;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
`;
const ControlsWrapper = styled.div `
  display: flex;
  gap: 8px;
  user-select: none;
  margin-bottom: 15px;
  justify-content: flex-end;

  ${() => ButtonStyles.Container}:focus {
    outline: none;
  }

  @media ${until(Device.TabletLarge)} {
    gap: 8px;
    grid-column: 1 / span 12;
    grid-row: 3;
    justify-self: flex-end;
  }

  @media ${from(Device.TabletLarge)} {
    gap: 32px;
    grid-column: 1 / span 3;
    grid-row: 2;
  }

  ${inViewFadeUp({ delay: 0.3, duration: 0.3 })};
`;
const CaptionWrapper = styled.div `
  overflow: hidden;
  width: 100%;
  position: relative;
`;
const Picture = styled.picture `
  ${({ isCustomHeight }) => isCustomHeight &&
    css `
      margin: auto;
    `}
`;
const Caption = styled(m.div).attrs(() => ({
    initial: 'hidden-bottom',
    animate: 'visible',
    exit: 'hidden-top',
    variants: {
        'hidden-bottom': {
            y: '100%',
            opacity: 0,
            position: 'absolute',
        },
        visible: {
            y: 0,
            opacity: 1,
            position: 'relative',
        },
        'hidden-top': {
            y: '-100%',
            opacity: 0,
            position: 'absolute',
        },
    },
})) `
  display: block;
  ${paragraph};
  margin-top: 2rem;
`;
export const ImageCarouselStyles = {
    Container,
    IntroContent,
    Title,
    Content,
    CarouselContainer,
    CarouselInner,
    CarouselWrapper,
    Item,
    Image,
    ItemInner,
    ControlsWrapper,
    Caption,
    CaptionWrapper,
    Picture,
};
